module.exports = __webpack_public_path__ + "img/img_pro.33d82a47.png";